import { UpdateEntityDetailsClientRequest } from '../../../@types/UpdateEntityDetails'
import { FormAddressValuesProps } from '../../../Components/OwnerData/components/AddressForm'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { ID_EXTERNAL_TYPES } from '../../../constants/idExternalTypes'
import {
  streetNameFormatted,
  truncateAddress,
} from '../../../utils/streetNameFormatted'

export const useAddressesUpdateEntityPayload = () => {
  const { policyholderDetailsSelected, policyholderAddressSelected } =
    usePolicyholderDetailsStore()

  const handleAddressesPayload = (formValues: FormAddressValuesProps) => {
    const [zipCode, zipCodeExtension] = (
      formValues?.entityZipCode || ''
    )?.split('-')

    const addressTruncated = truncateAddress(formValues, 'entityComplement')

    const payload: UpdateEntityDetailsClientRequest = {
      idEntity: policyholderDetailsSelected?.idEntity || '',
      entityType: 'Individual', // TODO: hardcoded
      idExternalType: ID_EXTERNAL_TYPES.globalEntity || '',
      countryCode:
        policyholderDetailsSelected?.addresses?.[0]?.countryCode || '',
      addressRequest: {
        type: '2', //TODO: Review where to get data
        streetType: addressTruncated.entityTypeArteria || '',
        streetName: streetNameFormatted(
          addressTruncated?.entityNameArteria || '',
          policyholderAddressSelected?.typology?.postalAddress?.roadType || '',
        ),
        floor: addressTruncated?.entityFloor || '',
        houseNumber: addressTruncated.entityNumberPolice || '',
        doorNumber: addressTruncated?.entityNumberDoor || '',
        complement: addressTruncated?.entityComplement || '',
        zipCode: zipCode || '',
        zipCodeExtension: zipCodeExtension || '',
        town: addressTruncated.entityLocalization || '',
        fraction: '', //TODO: Review where to get data
        address: addressTruncated?.entityNameArteria || '',
        sequence: '', // policyholderDetailsSelected?.addresses?.[0]?.sequence
      },
    }

    return payload
  }

  return {
    handleAddressesPayload,
  }
}
